import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useEffectOnce } from "react-use";
import "./job_alert.scss";
import { Body, Link } from "./typography";
import ReminderIcon from "./icons/reminder";
import { useBoardConfiguration } from "~/hooks/use_board_configuration";
import classNames from "classnames";
import { SnowplowEvent, useSnowplowTracker } from "~/hooks/use_snowplow_tracker";

interface Props {
  urlToken?: string;
  companyName?: string;
  onJobPost?: boolean;
}

export const JobAlert = ({ urlToken = "", companyName = "", onJobPost = false }: Props) => {
  const { t } = useTranslation("job_post");
  const [jobSeekersUrl, setJobSeekersUrl] = useState("");
  const { preview_mode } = useBoardConfiguration();
  const { trackEvent } = useSnowplowTracker();
  const event_type = `job_alert_${onJobPost ? "post" : "board"}`;

  useEffectOnce(() => {
    if (!preview_mode) {
      trackEvent(SnowplowEvent.MyGreenhouseAdShown, {
        type: event_type,
      });
      setJobSeekersUrl(
        `${window.ENV.JOB_SEEKERS_URL}/users/sign_in?job_board=${urlToken}&source=${event_type}`
      );
    }
  });

  const classes = classNames({
    "job-alert": true,
    "job-alert--margin": onJobPost,
  });

  const trackClicks = () => {
    trackEvent(SnowplowEvent.MyGreenhouseAdClicked, {
      type: event_type,
    });
  };

  const descriptionKey = onJobPost ? "job_alert.post_description" : "job_alert.board_description";

  return (
    <div className={classes}>
      <ReminderIcon />
      <div>
        <Body medium>{t("job_alert.title")}</Body>
        <Body>{t(descriptionKey, { companyName, interpolation: { escapeValue: false } })}</Body>
        <Link
          target="_blank"
          href={preview_mode ? undefined : jobSeekersUrl}
          onClick={preview_mode ? undefined : trackClicks}
          rel="noreferrer"
        >
          {t("job_alert.create")}
        </Link>
      </div>
    </div>
  );
};
